import script from "./MyAbsences.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAbsences.vue?vue&type=script&setup=true&lang=js"

import "./MyAbsences.vue?vue&type=style&index=0&id=7469d45b&scoped=true&lang=scss"
import "./MyAbsences.vue?vue&type=style&index=1&id=7469d45b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7469d45b"]])

export default __exports__